import axios from 'axios'

export default {
    async search(filters = {}) {
        const response = await axios.get('/api/search_logs', { params: filters });
        return response.data;
    },
}
